/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery( document ).ready( function () {
    
    // Remove empty P tags created by WP inside of Accordion and Orbit
    jQuery( '.accordion p:empty, .orbit p:empty' ).remove();
    
    // Adds Flex Video to YouTube and Vimeo Embeds
    jQuery( 'iframe[src*="youtube.com"], iframe[src*="vimeo.com"]' ).each( function () {
        if ( jQuery( this ).innerWidth() / jQuery( this ).innerHeight() > 1.5 ) {
            jQuery( this ).wrap( "<div class='widescreen responsive-embed'/>" );
        } else {
            jQuery( this ).wrap( "<div class='responsive-embed'/>" );
        }
    } );
    
    var languageSwitcher = jQuery( '[data-language-switcher]' );
    
    jQuery( window ).on( 'open.zf.reveal', function () {
        if ( languageSwitcher.hasClass( 'scrolled' ) ) {
            languageSwitcher.addClass( 'scrolled--visible' );
        }
    } );
    
    jQuery( window ).on( 'closed.zf.reveal', function () {
        if ( languageSwitcher.hasClass( 'scrolled--visible' ) ) {
            languageSwitcher.removeClass( 'scrolled--visible' );
        }
    } );
    
    jQuery( window ).on( 'opened.zf.offcanvas', function () {
        languageSwitcher.addClass( 'language-switcher--visible' );
        jQuery('.logo-tag').fadeOut(300);
    } );
    
    jQuery( window ).on( 'closed.zf.offcanvas', function () {
        languageSwitcher.removeClass( 'language-switcher--visible' );
        jQuery('.logo-tag').fadeIn(300);
    } );
} );
